import { InjectionToken } from '@angular/core';

export interface SharedConfig {
  applicationName: string;
}

export const SHARED_CONFIG = new InjectionToken<SharedConfig>('shared.config');
